import { useEffect, useState } from 'react'

import { ArrowPathRoundedSquareIcon } from '@heroicons/react/24/outline'

import useServerArea from '@/api/useServerArea'
import defaultUserAvatar from '@/assets/user-default.jpg'
import DetailMovement from '@/containers/areas/stock/movements/DetailMovement'
import { formatCalendar } from '@/utils/helpers'
import { translateMeasure } from '@/utils/translate'

import MovementsTypeBadge from './badges/MovementsTypeBadge'
import EmptyList from './EmptyList'
import Modal from './GenericModal'
import SpinnerLoading from './SpinnerLoading'

const LastOperationsCard = () => {
  const { getMovementByArea, allMovements, isLoading } = useServerArea()
  const [modalMovement, setModalMovement] = useState<{
    movementId: number | null
    modalState: boolean
  }>({ movementId: null, modalState: false })

  useEffect(() => {
    getMovementByArea({ operation: 'WASTE,OUT', per_page: 15 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      {modalMovement.modalState && (
        <Modal
          close={() =>
            setModalMovement({
              modalState: false,
              movementId: null,
            })
          }
          size="l"
          state={modalMovement.modalState}
        >
          <DetailMovement id={modalMovement.movementId} />
        </Modal>
      )}
      <div className="flex items-center gap-2">
        <h1 className="text-lg font-bold text-gray-900">
          Últimas operaciones de merma y salidas
        </h1>
        <ArrowPathRoundedSquareIcon className="h-6 animate-pulse" />
      </div>
      <div
        className={
          'max-h-[22rem] overflow-y-auto border border-gray-200 bg-white ' +
          'scrollbar-thin scrollbar-thumb-gray-400'
        }
      >
        {isLoading ? (
          <SpinnerLoading className="py-[2.14rem]" />
        ) : allMovements.length > 0 ? (
          <ul className="border border-gray-200" role="list">
            {allMovements.map((movement) => (
              <li
                className="flex justify-between gap-x-6 py-5 odd:bg-gray-100 hover:cursor-pointer"
                key={movement.id}
                onClick={() =>
                  setModalMovement({
                    modalState: true,
                    movementId: movement.id,
                  })
                }
              >
                <div className="ml-4 flex w-[50%] min-w-0 items-center justify-center gap-x-4">
                  <img
                    alt="Moved by Picture"
                    className="h-12 w-12 flex-none rounded-full bg-gray-50"
                    src={
                      movement.movedBy.avatar?.thumbnail ?? defaultUserAvatar
                    }
                  />
                  <div className="min-w-0 flex-auto justify-center">
                    <p className="text-sm font-semibold">
                      {movement.movedBy.displayName}
                    </p>
                    <p className="mt-1 truncate text-xs text-gray-500">
                      {movement.area.name}
                    </p>
                  </div>
                </div>
                <div
                  className={
                    'hidden w-[26%] shrink-0 items-center justify-center ' +
                    'sm:flex sm:flex-col'
                  }
                >
                  <MovementsTypeBadge operation={movement.operation} />
                  <p className="mt-1 text-xs text-gray-500">
                    {formatCalendar(movement.createdAt.toString(), true)}
                  </p>
                </div>
                <div
                  className={
                    'mr-1 hidden w-[24%] shrink-0 items-center justify-center ' +
                    'sm:flex sm:flex-col sm:flex-wrap'
                  }
                >
                  <p className="text-center text-sm font-semibold">
                    {movement.product.name}
                  </p>
                  <p className="mt-1 text-xs text-gray-500">
                    {movement.quantity * -1}{' '}
                    {translateMeasure(movement.product.measure)}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="py-[1.5rem]">
            <EmptyList />
          </div>
        )}
      </div>
    </div>
  )
}

export default LastOperationsCard
